import './style.css';
import mapComponent from './map-component.js';

const map = mapComponent.initMap({
  target: 'map_canvas',
  center: [10.0, 51.0],
  zoom: 6,
  localTileUrl: 'http://127.0.0.1/plz-de/{z}/{x}/{y}.png'
});

// expose lightweight compatibility reference for legacy code
window.map = mapComponent;

